const graphic_carousel = () => {

    $('.graphic_carousel--dark-slider').slick({
        dots: true,
        infinite: true,
        prevArrow: '',
        nextArrow: '.graphic_carousel--dark-next',
    });

    $('.graphic_carousel--light-slider')
    .on('afterChange init', function(event, slick, direction){
        slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
    
        for (var i = 0; i < slick.$slides.length; i++)
        {
            var $slide = $(slick.$slides[i]);
            if ($slide.hasClass('slick-current')) {
                $slide.prev().addClass('prevSlide');
                $slide.next().addClass('nextSlide');
                break;
            }
        }
      }
    )
    .on('beforeChange', function(event, slick) {
        slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
    })
    .slick({
        dots: true,
        infinite: true,
        prevArrow: '',
        nextArrow: '.graphic_carousel--light-next'
    });


    $(".graphic_carousel--light-slider_slide p").addClass("mh1");
};

export default graphic_carousel;